import React, { ComponentType, forwardRef } from "react";
import {
  Field,
  Formula,
  Cell,
  Loop,
  TableEditorConfig,
  TableEditorProps,
  TableEditorRef,
  TableViewerProps,
  Selection,
  TableViewerRef,
  Value,
} from "./dto";
import SettlementStoreProvider from "./store";
import Viewer from "./viewer";
import InnerTableEditor from "./editor";
import Panel from "./panel";
import { isListValue } from "./utils";
import { DATA_TYPE, FORMULA_TYPE, VALUE_TYPE } from "./contanst";
import useFlattenFields from "./hooks/use-flatten-fields";

import "./index.less";

const withCombine = <T, P>(
  Component: ComponentType<T>,
  combine: P
): ComponentType<T> & P => Object.assign(Component, combine);

// 组合 TableEditor 组件
const TableEditorWithStore = forwardRef(
  (props: TableEditorProps, ref: React.Ref<TableEditorRef>) => {
    return (
      <SettlementStoreProvider>
        <div className="wbuc-flex wbuc-size-full wbuc-gap-5">
          <InnerTableEditor {...props} ref={ref} />
          <Panel fields={props.fields} />
        </div>
      </SettlementStoreProvider>
    );
  }
);

const TableEditor = withCombine(TableEditorWithStore, { Viewer });

export default TableEditor;

export { isListValue, useFlattenFields, VALUE_TYPE, DATA_TYPE, FORMULA_TYPE };

export type {
  Field,
  Selection,
  Formula,
  Cell,
  Loop,
  Value,
  TableEditorRef,
  TableEditorProps,
  TableEditorConfig,
  TableViewerProps,
  TableViewerRef,
};
